module.exports = __webpack_public_path__ + "static/media/PrincessAshibuogwu.7f34a097.jpg";